import type { RouteObject } from 'react-router';
import { AccountingPeriodsPage } from './pages/AccountingPeriodsPage';
import { ACCOUNTING_PERIODS_PATH } from './accounting-periods.paths';

export const ACCOUNTING_PERIOD_ROUTES: RouteObject[] = [{ path: ACCOUNTING_PERIODS_PATH.slice(1), element: <AccountingPeriodsPage /> }];
